export function parseTechnology(decorationTechnology) {
    if (decorationTechnology === undefined)
        return "offsetOrDigital";
    const normalizedTechnology = decorationTechnology.toLowerCase();
    return normalizedTechnology.indexOf("embroidery") >= 0 ? "embroidery" : "offsetOrDigital";
}
//# sourceMappingURL=Technology.js.map